import React from "react";
import { useNavigate } from "react-router-dom";
import { Folders, InternatlServerError, Layout, LoadingSection } from "../../../components";
import { BreadScrumHeaderHistoryProp } from "../../../interfaces";
import { useAppSelector } from "../../../redux";
import { useGetFoldersQuery } from "../../../redux/services";
import { HasAccess } from "../../../router/authorization";
import { PERMISSIONS } from "../../../router/permission";
import { AppRoutes } from "../../../router/routes";
import { ROOT_FOLDER_NAME } from "../../../utils";

export const FolderView: React.FC<{ children?: JSX.Element, openDocumentHistory: (document_id: string) => void }> = (props) => {

    const navigate = useNavigate();
    const { perm } = useAppSelector(store => store.auth.userDetails);
    const getFolderData = useGetFoldersQuery({ sequence_id: 'F-000001' })

    const [currentPath, setCurrentPath] = React.useState<string>(ROOT_FOLDER_NAME);
    const [history, setHistory] = React.useState<BreadScrumHeaderHistoryProp[]>([
        { label: "Documents", onClick: () => navigate(AppRoutes.documents) }
    ]);

    const creatable = React.useMemo(() => HasAccess(perm, PERMISSIONS.DOCUMENT_CREATE), [perm]);
    const readable = React.useMemo(() => HasAccess(perm, PERMISSIONS.DOCUMENT_READ), [perm]);
    const updatable = React.useMemo(() => HasAccess(perm, PERMISSIONS.DOCUMENT_UPDATE), [perm]);
    const deletable = React.useMemo(() => HasAccess(perm, PERMISSIONS.DOCUMENT_DELETE), [perm]);
    const publishable = React.useMemo(() => HasAccess(perm, PERMISSIONS.DOCUMENT_PUBLISH), [perm]);

    const updateBreadScrumHistory = (appendHistory: BreadScrumHeaderHistoryProp[] = []) => {
        let breadScrumHistory: BreadScrumHeaderHistoryProp[] = [
            { label: "Documents", onClick: () => navigate(AppRoutes.documents) }
        ];
        setHistory([...breadScrumHistory, ...(appendHistory.filter(a => a.label !== "Documents"))]);
    };

    if (getFolderData.isLoading || getFolderData.isFetching) {
        return <LoadingSection message="Fetching..." />
    }

    if (getFolderData.isError) {
        return <InternatlServerError message="Something went wrong unable to build document module." />
    }

    if (getFolderData.data?.data?.length) {

        return <>
            {/* Breadscrum */}
            <Layout
                currentPath={currentPath}
                history={history}
                navBars={[]}
                mainPanel={<Folders
                    currentItem={getFolderData.data?.data?.[0]}
                    sequence_id={getFolderData.data?.data?.[0]?.sequence_id}
                    showCreateBtn={true}
                    updateHistory={(newHistory, currentPath) => {
                        updateBreadScrumHistory([...newHistory.map(_ => ({ label: _.label, onClick: () => navigate(AppRoutes.documents + "?folderId=" + _.value) }))]);
                        setCurrentPath(currentPath);
                    }}
                    updateCurrentPath={(path) => setCurrentPath(path)}
                    creatable={creatable}
                    updatable={updatable}
                    deletable={deletable}
                    readable={readable}
                    publishable={publishable}
                    isCommonModule
                />}
                sideNavVariant={"whiteboard"}
            />
        </>
    } else {
        return <InternatlServerError message="Something went wrong unable to build document module." />
    }
}

